import React, { Fragment, useState, useEffect } from "react";
import { Container, Media, Row, Col, Card, InputGroup, InputGroupText, InputGroupAddon, Input } from "reactstrap";
import { Save, AlertCircle } from "react-feather";
import { useTimer } from 'react-timer-hook';

import NinjaHikeLogo       from "~/assets/images/tournament/NinjaHike-logo.png";
import RewardListIcon      from "~/assets/images/tournament/rewards.png";
import CurrentRankIcon     from "~/assets/images/tournament/rank.png";
import GuideIcon           from "~/assets/images/tournament/guide.png";
import PreviousWinnersIcon from "~/assets/images/tournament/winners.png";
import BreakRecordIcon from "~/assets/images/tournament/military-rank.png";

import GooglePlayImg from "~/assets/images/tournament/google-play-badge.png";
import AppStoreImg   from "~/assets/images/tournament/apple-store-badge.png";

import OverlayModal from "~/components/overlayModal";
import Msg          from '~/components/messages';

import User from "~/services/user";
import Game from "~/services/games";

import RewardsModal       from "./Modals/Rewards";
import GuideModal         from "./Modals/Guide";
import DragonHitTokenInfo from "./Modals/DragonHitTokenInfo";
import BreakTheRecord from "./Modals/BreakTheRecord";

import LeaderBoard  from "~/pages/LeaderBoard";


const NinjaHikeContest = ({user})=> {

  const [overlayOpen  , setOverlayOpen ] = useState(false);
  const [selectedView , setSelectedView] = useState({title: "", view: "" });
  const [gamesKey     , setGamesKey    ] = useState("");
  const [playUrl      , setPlayUrl]      = useState('');

  const gameId = 14;

  const modals = {
    breakRecord: { view: BreakTheRecord     , title: "Break The Record"  , props: {gameId} },
    rewards    : { view: RewardsModal       , title: "Rewards List" },
    ranking    : { view: LeaderBoard        , title: "Leaderboard", bg : "#eef2f6", className: "no-scroll" , props: { day :  0, gameId: gameId }},
    winners    : { view: LeaderBoard        , title: "Leaderboard", bg : "#eef2f6", className: "no-scroll" , props: { day : -1, gameId: gameId }},
    guide      : { view: GuideModal         , title: "How to play"  },
    tokenInfo  : { view: DragonHitTokenInfo                       , props: { setOverlayOpen, gameId }  }
  };

  const currentDay = new Date();
  currentDay.setUTCHours(23,59,59,999);
  const { seconds, minutes, hours } = useTimer({ expiryTimestamp: currentDay });

  useEffect(()=> {
    (async()=> {
      setPlayUrl(await Game.getPlayUrl(gameId));
      Game.getGamesKey(gameId)
      .then(setGamesKey)
      .catch(err => Msg.general(err.gamesKey, {type: "error"}));
    })();
  }, []);

  const setGameKey = ()=> {
    User.setGamesKey({gamesKey}, gameId)
      .then(()=>Msg.general("Ninja Hike ID Saved"))
      .catch((err)=>{
        Msg.general(err.gamesKey || err.generalError, {type: "error"});
      });
  };

  const openModal = (item)=> {
    setSelectedView(modals[item]);
    setOverlayOpen(true);
  };

  return (
    <div className="tournament-page">
      <Container fluid={true}>

        <Row>
          <Col xs="6" lg="4" onClick={()=> openModal('rewards')} className="modal-info">
            <Card body>
              <Media body>
                <img src={RewardListIcon} />
                <span>Rewards</span>
              </Media>
            </Card>
          </Col>


          <Col xs="6" lg="4" onClick={()=> openModal('breakRecord')}  className="modal-info">
            <Card body>
              <Media body >
                <img src={BreakRecordIcon} />
                <span>Break The Record</span>
              </Media>
            </Card>
          </Col>

          <Col xs="12" lg="4" onClick={()=> openModal('ranking')}  className="modal-info">
            <Card body>
              <Media body className="modal-ranking">
                <img src={CurrentRankIcon} />
                <span>Ranking</span>
              </Media>
            </Card>

          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <Card body>
              <Media body className="step step-1">
                <p className="step-badge"> Step 1 </p>
                <div className="title">
                  <p> <img src={NinjaHikeLogo} style={{borderRadius: "15px"}}/>  <span> Download the Ninja Hike Game from: </span> </p>
                </div>

                <div className="info-box">
                  <a href={playUrl} className="text-dark text-center m-r-10">
                    <img src={GooglePlayImg}  />
                  </a>
                  { /* <a href="https://apps.apple.com/us/app/dragon-hit-challenge/id1621749850" className="text-dark m-l-10">
                    <img src={AppStoreImg}  />
                  </a> */ }
                </div>
                <p className="timer">
                  Current round ends in: <strong> {hours < 10 ? '0' : ''}{hours}:{minutes < 10 ? '0' : ''}{minutes}:{seconds < 10 ? '0' : ''}{seconds} </strong>
                </p>
              </Media>
            </Card>
          </Col>

          <Col sm="12">
            <Card body>
              <Media body className="step step-2">
                <p className="step-badge"> Step 2  <AlertCircle className="game-info" onClick={()=> openModal("tokenInfo") } /></p>

                <div className="title">
                  <p> Insert here the ID from Ninja Hike </p>
                </div>

                <InputGroup className="input-group-round ref-input">
                  <InputGroupAddon addonType="prepend"><InputGroupText  className="span-left"><strong>ID TOKEN</strong></InputGroupText></InputGroupAddon>
                  <Fragment>
                    <Input className="form-control" type="text" value={gamesKey} onChange={(e)=> setGamesKey(e.target.value)} placeholder="Insert your Token" />
                    <InputGroupAddon addonType="append"><InputGroupText  className="divider span-right"><Save title="Set token"  className="text-muted" onClick={setGameKey} /></InputGroupText></InputGroupAddon>
                  </Fragment>
                </InputGroup>
              </Media>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="6" className="modal-info" onClick={()=> openModal('winners')}>
            <Card body>
              <Media body>
                <img src={PreviousWinnersIcon} />
                <span> Winners </span>
              </Media>
            </Card>
          </Col>

          <Col xs="6" className="modal-info" onClick={()=> openModal('guide')}>
            <Card body>
              <Media body>
                <img src={GuideIcon} />
                <span> Guide </span>
              </Media>
            </Card>
          </Col>
        </Row>

      </Container>

      <OverlayModal className={selectedView.className} title={selectedView.title} opened={overlayOpen} onClose={()=> setOverlayOpen(false)} bg={selectedView.bg}>
        { selectedView.view ? <selectedView.view { ...selectedView.props } /> : null }
      </OverlayModal>
    </div>

  );
};

export default NinjaHikeContest;
